import { Grid } from "@mui/material";
import {
    TLAHardewareInterfaceGstDecklinkModesType,
    TLAHardewareInterfaceGstDecklinkProfileIdType,
    TLAHardewareInterfaceGstDecklinkVideoFormatType,
    TLAHardwareInterfaceDecklinkConnectionType,
} from "../../../__generated__/globalTypes";
import HESPFormLabel from "../../HESPFormLabel/HESPFormLabel";
import HardwareInterfaceSelector from "../HardwareInterfaceSelector/HardwareInterfaceSelector";
import {
    getDecklinkConnections,
    getDecklinkModes,
    getDecklinkProfiles,
    getDecklinkVideoFormats,
} from "../../TLA/tla-mappings";

interface Props {
    values: ChannelSdiAdditionalParams;
    onChangeValues: (values: ChannelSdiAdditionalParams) => void;
    size?: "medium" | "small";
}

export interface ChannelSdiAdditionalParams {
    audioConnection: TLAHardwareInterfaceDecklinkConnectionType;
    videoConnection: TLAHardwareInterfaceDecklinkConnectionType;
    videoFormat: TLAHardewareInterfaceGstDecklinkVideoFormatType;
    videoMode: TLAHardewareInterfaceGstDecklinkModesType;
    profile: TLAHardewareInterfaceGstDecklinkProfileIdType;
}

export default function ChannelSdiManagement({ onChangeValues, values, size }: Props): JSX.Element {
    return (
        <Grid container spacing={size === "small" ? 1 : 2}>
            <Grid item xs={12} md={6}>
                <HESPFormLabel size={size} label="Audio connection" />
                <HardwareInterfaceSelector
                    size={size}
                    items={getDecklinkConnections().map((connection) => ({
                        id: connection.key,
                        name: connection.value,
                    }))}
                    selected={values.audioConnection}
                    onChangeSelected={(key: string) =>
                        onChangeValues({
                            ...values,
                            audioConnection: key as TLAHardwareInterfaceDecklinkConnectionType,
                        })
                    }
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <HESPFormLabel size={size} label="Video connection" />
                <HardwareInterfaceSelector
                    size={size}
                    items={getDecklinkConnections().map((connection) => ({
                        id: connection.key,
                        name: connection.value,
                    }))}
                    selected={values.videoConnection}
                    onChangeSelected={(key: string) =>
                        onChangeValues({
                            ...values,
                            videoConnection: key as TLAHardwareInterfaceDecklinkConnectionType,
                        })
                    }
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <HESPFormLabel size={size} label="Video mode" />
                <HardwareInterfaceSelector
                    size={size}
                    items={getDecklinkModes().map((mode) => ({
                        id: mode.key,
                        name: mode.value,
                    }))}
                    selected={values.videoMode}
                    onChangeSelected={(key: string) =>
                        onChangeValues({
                            ...values,
                            videoMode: key as TLAHardewareInterfaceGstDecklinkModesType,
                        })
                    }
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <HESPFormLabel size={size} label="Video format" />
                <HardwareInterfaceSelector
                    size={size}
                    items={getDecklinkVideoFormats().map((format) => ({
                        id: format.key,
                        name: format.value,
                    }))}
                    selected={values.videoFormat}
                    onChangeSelected={(key: string) =>
                        onChangeValues({
                            ...values,
                            videoFormat: key as TLAHardewareInterfaceGstDecklinkVideoFormatType,
                        })
                    }
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <HESPFormLabel size={size} label="Profile" />
                <HardwareInterfaceSelector
                    size={size}
                    items={getDecklinkProfiles().map((profile) => ({
                        id: profile.key,
                        name: profile.value,
                    }))}
                    selected={values.profile}
                    onChangeSelected={(key: string) =>
                        onChangeValues({
                            ...values,
                            profile: key as TLAHardewareInterfaceGstDecklinkProfileIdType,
                        })
                    }
                />
            </Grid>
        </Grid>
    );
}
